var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D4EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 40.0616C34.3853 40.0616 39.5616 34.8853 39.5616 28.5C39.5616 22.1148 34.3853 16.9385 28 16.9385C21.6148 16.9385 16.4385 22.1148 16.4385 28.5C16.4385 34.8853 21.6148 40.0616 28 40.0616Z",
    stroke: "#0071DA",
    strokeWidth: 2.31231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3754 30.8123C23.3754 30.8123 25.1096 33.1246 28 33.1246C30.8904 33.1246 32.6246 30.8123 32.6246 30.8123",
    stroke: "#0071DA",
    strokeWidth: 2.31231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5316 25.0315H24.5417",
    stroke: "#0071DA",
    strokeWidth: 2.31231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4685 25.0315H31.4786",
    stroke: "#0071DA",
    strokeWidth: 2.31231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame 1.204c1d92e733d3569db61cb3be7b7bb9.svg";
export { ForwardRef as ReactComponent };